import React from 'react';
import Footer from '../../navigation/Footer';

const Profile = () => {
  return (
    <div className='profile'>
      Profile Wrapper
      <Footer/>
    </div>
  )
}

export default Profile;